"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _StateHelper = _interopRequireDefault(require("../helpers/StateHelper.js"));
var _BoardExamDate = _interopRequireDefault(require("../factories/BoardExamDate.js"));
var _constants = require("../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var stateHelper = new _StateHelper.default(_BoardExamDate.default);
var initialState = stateHelper.initialState;
exports.initialState = initialState;
var reducers = {};
reducers[_constants.BOARD_EXAM_DATES_FETCHED] = function (state, payload) {
  return state.withMutations(function (newState) {
    Object.entries(payload).forEach(function (exam) {
      var bed = exam[1];
      if (_typeof(bed) === 'object') {
        newState.set("".concat(bed.id), new _BoardExamDate.default({
          id: "".concat(bed.id),
          attributes: {
            user_id: bed.user_id,
            exam_date: bed.exam_date,
            follow_up: bed.follow_up,
            postponed: bed.postponed,
            first_quiz_completed: bed.first_quiz_completed,
            question_bank_id: bed.question_bank_id,
            study_frequency: bed.study_frequency,
            updated_at: bed.updated_at
          },
          relationships: {
            question_bank: {
              data: {
                id: bed.question_bank_id
              }
            },
            user: {
              data: {
                id: bed.user_id
              }
            }
          }
        }));
      }
    });
  });
};
reducers[_constants.BOARD_EXAM_DATE_UPDATED] = function (state, payload) {
  return state.withMutations(function (newState) {
    var bed = payload;
    newState.set("".concat(bed.id), new _BoardExamDate.default({
      id: "".concat(bed.id),
      attributes: {
        user_id: bed.user_id,
        exam_date: bed.exam_date,
        follow_up: bed.follow_up,
        postponed: bed.postponed,
        first_quiz_completed: bed.first_quiz_completed,
        question_bank_id: bed.question_bank_id,
        study_frequency: bed.study_frequency,
        updated_at: bed.updated_at
      },
      relationships: {
        question_bank: {
          data: {
            id: bed.question_bank_id
          }
        },
        user: {
          data: {
            id: bed.user_id
          }
        }
      }
    }));
  });
};
var _default = exports.default = stateHelper.createReducer(reducers);